import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarAnexosColectivosGruposRequest } from '../../models/cotizador-contratante/consultar-anexos-colectivos-grupos/request/consultar-anexos-colectivos-grupos-request.model';
import { ConsultarAnexosColectivosGruposResponse } from '../../models/cotizador-contratante/consultar-anexos-colectivos-grupos/response/consultar-anexos-colectivos-grupos-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarAnexosColectivosGruposService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.ANEXOS_COLECTIVOS_GRUPOS}`;

  constructor(private httpClient: HttpClient) { }

  consultarAnexosColectivosGrupos(
    request: ConsultarAnexosColectivosGruposRequest
  ): Observable<ConsultarAnexosColectivosGruposResponse> {
    return this.httpClient.post<ConsultarAnexosColectivosGruposResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarAnexosColectivosGrupos:', error);
        return throwError(() => new Error(error?.message || 'Error al consultar anexos'));
      })
    );
  }



  buildRequest(params: { tipoPlan: string; cuenta: string; subcuenta?: string; planGrupo?: string; planCodi?: string; edad?: string; sexo?: string; }): ConsultarAnexosColectivosGruposRequest {
  const tipoPlan = (params?.tipoPlan ?? '').toString().trim().toUpperCase();
  const esColectivoOAfinidad = tipoPlan === 'C' || tipoPlan === 'CY' || tipoPlan === 'GA' || tipoPlan === 'AG' || tipoPlan.includes('COLECTIV') || tipoPlan.includes('AFINIDAD');
  const planCodi = (params?.planCodi ?? '').toString().trim().toUpperCase();

  const jsonParams = esColectivoOAfinidad ? {
    prm_cuenta: (params?.cuenta ?? '').toString().trim(),
    prm_subcta: (params?.subcuenta ?? '').toString().trim(),
    prm_plan_grupo: (params?.planGrupo ?? '').toString().trim(),
    prm_plan_codi: '',
    prm_edad: (params?.edad ?? '').toString().trim(),
    prm_sexo: (params?.sexo ?? '').toString().trim()
  } : {
    prm_cuenta: (params?.cuenta ?? '').toString().trim(),
    prm_plan_codi: planCodi,
    prm_edad: (params?.edad ?? '').toString().trim(),
    prm_sexo: (params?.sexo ?? '').toString().trim(),
    

    prm_subcta: (() => {
      const subctaPasada = (params?.subcuenta ?? '').toString().trim().toUpperCase();
      
 
      const subcuentasValidas = ['ASMP', 'EMSMP', 'FSMP', 'ASAO', 'FSAO', 'EMSAO', 'ACEMN', 'EMCMN', 'FCEMN'];
      
      if (subctaPasada && subcuentasValidas.includes(subctaPasada)) {
        return subctaPasada;
      }

      // 1. Identificar Línea de Negocio real por código del plan
      let linea = 'SMP';
      if (planCodi.startsWith('DE') || planCodi.includes('SAO') || planCodi.includes('SO')) {
        linea = 'SAO';
      } else if (planCodi.includes('CEM')) {
        linea = 'CEM';
      }

      // 2. Normalizar el Tipo de Plan (A, F, E)
      let tipo = 'F';
      if (tipoPlan === 'A' || tipoPlan === 'AS' || tipoPlan.includes('ASOCIADO')) tipo = 'A';
      else if (tipoPlan === 'E' || tipoPlan === 'EMP' || tipoPlan.includes('EMPLEADO')) tipo = 'E';

      const matrizSubcuentas: Record<string, Record<string, string>> = {
        'SMP': { 'A': 'ASMP',  'F': 'FSMP',  'E': 'EMSMP' }, 
        'SAO': { 'A': 'ASAO',  'F': 'FSAO',  'E': 'EMSAO' },
        'CEM': { 'A': 'ACEMN', 'F': 'FCEMN', 'E': 'EMCMN' } 
      };

      return matrizSubcuentas[linea]?.[tipo] || 'FSMP';
    })()
  };

  return { nombreClave: 'getCotConsultarAnexosAfilmed', jsonParametros: JSON.stringify(jsonParams) };
}
}
